export const MEME_STORAGE = "memeveda_storage_ask_";
export const AVATAR_API = "https://joeschmoe.io/api/v1/random";
export const CLOUDINARY_URL =
  "cloudinary://122963572832985:cljbikiSpkzezPEJymfLCBe0Kwk@drnzyifg7";

export const BACKEND_URL = "https://memeveda.herokuapp.com";
// export const BACKEND_URL = "http://localhost:5000";
